<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    高新园站<br>
站点介绍<br>
高新园站位于铜鼓路与科技南路与深南大道交口处，位于深南大道中央绿化带下，呈东西走向。高新园站充分考虑到高新园区的建筑特点及区域文化，力求表现富有科技感的“数码空间”，蓝色与淡灰色，深与浅的对比，在营造空间亲和力的同时突现“蓝色科技”的主题。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:01	23:34	1号线	2分钟	4分40秒<br>
机场东	06:00	23:34	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:24	23:33	1号线	3分45秒	5分45秒<br>
机场东	06:24	23:34	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:24	00:33	1号线	3分45秒	5分45秒<br>
机场东	06:24	00:34	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
万象天地、深南大道北侧（东）、大冲路、大冲新村<br><br>
B出入口:<br>
深南大道北侧（西）、大冲小学、南山外国语学校、大冲中学<br><br>
C出入口:<br>
深南大道南侧（西）、TCL大厦<br><br>
D出入口:<br>
深南大道南侧（东）、德赛科技大厦<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 大冲①<br>
323、324、338、369、395、M358、M372、M413、M425、M433、M435、高峰专线31号、高峰专线138号、M554、高峰专线9号、高峰专线150号、高快巴士22号、M191、M194、高峰专线165号、M530<br><br>
B出入口:<br>
公交站名： 大冲②<br>
19、21、42、70、79、101、113、204、M109、223、234、M222、M398、M448、N4、N8、B608、高峰专线69<br><br>
C出入口:<br>
公交站名： 高新园地铁站<br>
72、B683、M467、高峰专线165号、M530<br><br>
C出入口:<br>
公交站名： 中科大夏<br>
B683、M345、M467、M530<br><br>
D出入口:<br>
公交站名： 大冲①<br>
323、324、338、369、395、M358、M372、M413、M425、M433、M435、高峰专线31号、M554、高峰专线9号、高峰专线150号、高快巴士22号、M191、M194<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>










